export default class FormData {
  constructor () {
    this.coord = {
      isUsed: false,
      minX: 0,
      maxX: 0,
      minY: 0,
      maxY: 0
    }
    this.lang = 'fr'
    this.quantData = {
      format: {
        isGeodata: false,
        isCsv: false,
        isText: false,
        isOther: false
      }
    }
    this.qualData = {
      format: {
        isGeodata: false,
        isCsv: false,
        isText: false,
        isOther: false
      }
    }
    this.observationPoint = {
      isPiezo: false,
      isWell: false,
      isSources: false,
      isOther: false,
      format: {
        isGeodata: false,
        isCsv: false,
        isText: false,
        isOther: false
      }
    }
    this.gwLevel = {
      isManual: false,
      isAuto: false
    }
    this.sourceFlow = {
      isManual: false,
      isAuto: false
    }
    this.plottingTest = {
      format: {
        isGeodata: false,
        isCsv: false,
        isText: false,
        isOther: false
      }
    }
    this.inSituMeasure = {
      isManual: false,
      isAuto: false,
      isDiagraphies: false
    }
    this.sample = {
      isSamplingPoint: false,
      isProtocol: false,
      isChemical: false
    }
    this.report = {
      isReport: false,
      isAppendice: false,
      isMap: false,
      isProfil: false,
      isPictures: false,
      isOther: false
    }
    this.comments = ''
  }
}
